var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 78,
    height: 78,
    rx: 15,
    fill: "#4A86F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_796_18115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6932 17C42.3266 17 45.4212 19.2945 46.5599 22.5H49.8196C52.8881 22.5 55.3828 24.9664 55.3828 28V55.5C55.3828 58.5336 52.8881 61 49.8196 61H27.5667C24.4983 61 22.0035 58.5336 22.0035 55.5V28C22.0035 24.9664 24.4983 22.5 27.5667 22.5H30.8264C31.9651 19.2945 35.0597 17 38.6932 17ZM38.6932 28C40.2317 28 41.4748 26.7711 41.4748 25.25C41.4748 23.7289 40.2317 22.5 38.6932 22.5C37.1546 22.5 35.9115 23.7289 35.9115 25.25C35.9115 26.7711 37.1546 28 38.6932 28ZM33.1299 39C33.1299 42.0336 35.6247 44.5 38.6932 44.5C41.7616 44.5 44.2564 42.0336 44.2564 39C44.2564 35.9664 41.7616 33.5 38.6932 33.5C35.6247 33.5 33.1299 35.9664 33.1299 39ZM48.4288 54.125C48.4288 50.3266 45.3169 47.25 41.4748 47.25H35.9115C32.0695 47.25 28.9575 50.3266 28.9575 54.125C28.9575 54.8812 29.5834 55.5 30.3483 55.5H47.038C47.8029 55.5 48.4288 54.8812 48.4288 54.125Z",
    fill: "#4A86F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_796_18115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3793,
    height: 44,
    fill: "white",
    transform: "matrix(-1 0 0 1 55.3828 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOverview);
export default __webpack_public_path__ + "static/media/clientOverview.b4611f0cae7f7a6d3ad65a6fd2291f29.svg";
export { ForwardRef as ReactComponent };